import type { MRT_Row } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { Checkbox } from '@mui/material'
import {
    getVirtualAliasId,
    type WOModelMatchStore,
} from './wo-model-match-store'
import { APIModelAliasReference } from '@visorpro/client'

export interface IsReviewedCellProps {
    row: MRT_Row<APIModelAliasReference>
    modelsStore: WOModelMatchStore
}

export const IsReviewedCell = observer<IsReviewedCellProps>(
    ({ row, modelsStore }) => {
        const userId = row.original.reviewed_by_user_id

        return (
            <Checkbox
                checked={!!userId}
                onChange={(_, checked) => {
                    const aliasKey = getVirtualAliasId(row.original)

                    if (aliasKey) {
                        const alias = modelsStore.aliasesByKey[aliasKey]

                        modelsStore.upsert({
                            input_model: alias.input_model,
                            input_manufacturer: alias.input_manufacturer,
                            product_model_ids: alias.product_model_ids,
                            is_reviewed: checked,
                        })
                    }
                }}
            />
        )
    },
)
